function setCompareFeatureHeight() {
  const modelCompareTable = document.querySelector('.model-compare-table')

  if (modelCompareTable) {
    const compareRows = modelCompareTable.querySelectorAll('.compare-table-row')
    const compareHeadings = modelCompareTable.querySelectorAll('.compare-table-heading')
    if (compareRows) {
      for (let i = 0; i < compareRows.length; i++) {
        const compareRow = compareRows[i]
        const compareRowHeight = compareRow.getBoundingClientRect().height
        compareRow.style.height = `${compareRowHeight}px`
      }
    }
    if (compareHeadings) {
      for (let i = 0; i < compareHeadings.length; i++) {
        const heading = compareHeadings[i]
        const { height } = heading.getBoundingClientRect()
        heading.style.height = `${height}px`
      }
    }
  }
}

setCompareFeatureHeight()
